import * as server from "@/utils/http"

export const _search = params => server.get("/physical-project/search", params);

export const _physicalProjectList = params => server.get("/physical-project/list", params);
export const _projectName = params => server.get("/physical-project/project-name", params);

export const _generalProject = params => server.get("/physical-project/general", params);

export const _copyProject = params => server.post("/physical-project/copy", params);

export const _get = params => server.get("/physical-project/get", params);

export const _save = params => server.postfrom(params.id ? "/physical-project/update" : "/physical-project/save", params);

export const _updateStatus = params => server.get("/physical-project/updateStatus", params);

